import { Autocomplete, Stack, TextField, Typography } from '@mui/material';
import { useFormik } from 'formik';
import { Search } from 'react-feather';
import ButtonWithLoading from 'src/components/common/ButtonWithLoading';
import FormikForm from 'src/components/common/FormikForm';
import ModalComponent from 'src/components/Modal/ModalComponent';

const PopupFilterVessels = ({
  open,
  handleClose,
  shipTypes,
  operators,
  owners,
  sharedLineServices,
  onFilter,
}: {
  open: boolean;
  handleClose: () => void;
  onFilter: (payload: Record<string, any>) => void;
  shipTypes?: Array<TypeVesselShip>;
  operators?: Array<TypeVesselOperator>;
  owners?: Array<TypeVesselOperator>;
  sharedLineServices?: Array<TypeVesselOperator>;
}) => {
  const formik = useFormik({
    enableReinitialize: true,
    initialValues: {
      ship_type: '',
      operator_id: '',
      owner_id: '',
      shared_line_service_id: '',
      teu_from: '',
      teu_to: '',
      s: '',
    },
    onSubmit: (values) => {
      onFilter(values);
      handleClose();
    },
  });

  return (
    <ModalComponent styleBox={{ width: 600 }} open={open} handleClose={handleClose}>
      <FormikForm formik={formik}>
        <Stack spacing={2}>
          <Typography textAlign={'center'} variant="h5">
            Filter Vessels
            <Typography variant="body2" color={'text.secondary'}>
              Please enter your search criteria below. <br /> The more fields you complete, the more targeted your
              results will be.
            </Typography>
          </Typography>
          <TextField
            id="s"
            name="s"
            value={formik.values.s}
            onChange={formik.handleChange}
            onBlur={formik.handleBlur}
            label="Vessel Name"
            size="small"
          />
          <Autocomplete
            value={shipTypes?.find((item) => item.name === formik.values.ship_type)}
            onChange={(e, value) => {
              formik.setFieldValue('ship_type', value?.name ?? '');
            }}
            renderInput={(params) => <TextField {...params} label="Ship Type" />}
            size="small"
            getOptionLabel={(option) => `${option.name}`}
            options={shipTypes ?? []}
          />
          <Autocomplete
            value={operators?.find((item) => item.id === formik.values.operator_id)}
            onChange={(e, value) => formik.setFieldValue('operator_id', value?.id ?? '')}
            renderInput={(params) => <TextField {...params} label="Operator" />}
            size="small"
            getOptionLabel={(option) => `${option.name}`}
            options={operators ?? []}
          />
          <Autocomplete
            value={owners?.find((item) => item.id === formik.values.owner_id)}
            onChange={(e, value) => formik.setFieldValue('owner_id', value?.id ?? '')}
            renderInput={(params) => <TextField {...params} label="Owner" />}
            size="small"
            getOptionLabel={(option) => `${option.name}`}
            options={owners ?? []}
          />
          <Autocomplete
            value={sharedLineServices?.find((item) => item.id === formik.values.shared_line_service_id)}
            onChange={(e, value) => formik.setFieldValue('shared_line_service_id', value?.id ?? '')}
            renderInput={(params) => <TextField {...params} label="Service" />}
            size="small"
            getOptionLabel={(option) => `${option.name}`}
            options={sharedLineServices ?? []}
          />
          <Stack alignItems={'center'} spacing={2} direction="row">
            <TextField
              value={formik.values.teu_from}
              name="teu_from"
              onChange={formik.handleChange}
              id="teu_from"
              type="number"
              fullWidth
              label="TEU from"
              size="small"
            />
            <span>-</span>
            <TextField
              value={formik.values.teu_to}
              name="teu_to"
              onChange={formik.handleChange}
              id="teu_to"
              type="number"
              fullWidth
              label="to"
              size="small"
            />
          </Stack>

          <ButtonWithLoading type="submit" startIcon={<Search size={18} />} isRounded variant="contained" size="large">
            Filter
          </ButtonWithLoading>
        </Stack>
      </FormikForm>
    </ModalComponent>
  );
};

export default PopupFilterVessels;
